module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AS - American Samoa.195385b3.svg";